module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vdige11-2f5eca3c93ffc1dabdf0d2f10b7a8320.jpg";